import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Button as ChakraButton } from '@chakra-ui/react';
import { ButtonSize, ButtonVariant } from '../../core/enums';
export const Button = /*#__PURE__*/ React.forwardRef(({ label, backgroundColor, color, 'data-dd-action-name': rawDataActionNameForDD, dataTestId, leftIcon, rightIcon, className = '', disabled = false, size = ButtonSize.MD, variant = ButtonVariant.PRIMARY, ...props }, ref)=>{
    // we have confirmed that all Buttons are not carrying PHI
    // "~" at the beginning signs the action so it will not be redacted
    // we usually draw from labels, but if we don't want to double ~~ if
    // they switch
    const verifiedActionNameForDD = rawDataActionNameForDD || label;
    const signedActionNameForDD = verifiedActionNameForDD.startsWith('~') ? verifiedActionNameForDD : `~${verifiedActionNameForDD}`;
    return /*#__PURE__*/ _jsx(ChakraButton, {
        ref: ref,
        ...props,
        variant: variant,
        disabled: disabled,
        leftIcon: leftIcon,
        rightIcon: rightIcon,
        size: size,
        className: className,
        color: color,
        backgroundColor: backgroundColor,
        "data-testid": dataTestId?.trim() ?? 'button',
        "data-dd-action-name": signedActionNameForDD,
        children: label
    });
});
Button.displayName = 'Button';
